import React from 'react';
import { Process } from '../components/Process';
import { FAQ } from '../components/FAQ';
import { Contact } from '../components/Contact';
import { PageHeader } from '../components/PageHeader';

export const ProcessPage: React.FC = () => {
  return (
    <div className="animate-fade-in-up">
      <PageHeader 
        title="Der//Prozess" 
        subtitle="Ablauf" 
      />
      <Process />
      <FAQ />
      <Contact />
    </div>
  );
};